// extracted by mini-css-extract-plugin
export var currencyInput = "_nw-1";
export var currencySymbol = "_nw-0";